import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConfService } from 'src/conf.service';
import { LocalStorageService } from './session.service';
import {AuthService} from './auth.service'
@Injectable({
  providedIn: 'root',
})
export class MenuDataService {
  constructor(private authService:AuthService) { }
  public toggleMenuBar: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  getSettingMenuList(): any[] {
    return [

      {
        label: 'Favorite Parts',
        routerLink: '/settings/searchEquipment',
        //icon:'pi pi-equipment'
      }
      , {
        label: 'Favorite Test Equipment',
        routerLink: '/settings/addEquipment',
        //icon:'pi pi-pencil'
      }
      ,
      {
        label: 'BART Vision',
        routerLink: '/settings/manageOem',
        //icon:'pi pi-file'
      }
      ,
      {
        label: 'Facility Format',
        routerLink: '/settings/massTransfer',
        //icon:'pi pi-setting'
      },
      
    ];
  }

  getPartMenuList(): any[] {
    return [

      {
        label: 'Vendors',
        routerLink: '/Administrator/vendors',
        //icon:'pi pi-equipment'
      }
      , {
        label: 'Parts',
        routerLink: '/settings/addEquipment',
        //icon:'pi pi-pencil'
      }
      ,
      {
        label: 'Merge',
        routerLink: '/settings/manageOem',
        //icon:'pi pi-file'
      }
      
      
      
    ];
  }



  getEquipmentMenuList(): any[] {
    return [

      {
        label: 'Search',
        routerLink: '/equipment/searchEquipment',
        //icon:'pi pi-equipment'
      }
      , {
        label: 'Add Equipment',
        routerLink: '//equipment/addEquipment',
        //icon:'pi pi-pencil'
      }
      ,
      {
        label: 'Manage OEM',
        routerLink: '//equipment/manageOem',
        //icon:'pi pi-file'
      }
      ,
      {
        label: 'Mass Transfer',
        routerLink: '//equipment/massTransfer',
        //icon:'pi pi-setting'
      }
      ,
      {
        label: 'Mass Update',
        routerLink: '//equipment/massUpdate',
        //icon:'pi pi-desktop'
      }
      ,
      {
        label: 'Name Manager',
        routerLink: '//equipment/nameManager',
        //icon:'pi pi-desktop'
      }
    ];
  }

  getMenuList(bartRoleCode:string): any[] {
    let authJson= [
      {
        label: 'Labs',
        routerLink: '/WaterLab',
        authorizeTo:['ADMIN','FA','LCU','UCU','HHD','BSS','BOM']
      },	// FREQ-685039 Role-based Entitlements
      {
        label: 'Service Request',
        routerLink: '/ServiceRequest',
        authorizeTo:['ADMIN','CLN','CLNX','BSSX','CLNSX','BOMX','CLNLNX','LNX']
        //icon:'pi pi-desktop'
      }
      // ,
      // {
      //   label: 'SystemX DashBoard',
      //   routerLink: '/systemXDashBoard',
      //   authorizeTo:['ADMIN','CLN','CLNX','BSSX','CLNSX','BOMX','CLNLNX','LNX']
      //   //icon:'pi pi-desktop'
      // }

      // , {
      //   label: 'Reintialize',
      //   routerLink: '/reinitialize',
      //   authorizeTo:[]
      //   //icon:'pi pi-pencil'
      // },
      ,
      {
        label: 'Dashboard',
        //icon: 'pi pi-fw pi-desktop',
        routerLink: '/dashboard',
        authorizeTo:['ADMIN','BOM','BSS','BSSX','BOMX']
      },
      {
        label: 'Equipment Manager',
        routerLink: '/equipment',
        authorizeTo:['ADMIN','BOM','BSS','ANALYST','HHD','BSSX','BOMX']
        //icon:'pi pi-equipment'
      },
      {
        label: 'Create Ticket',
        //icon: 'pi pi-fw pi-ticket',
        routerLink: '/tickets',
        authorizeTo:['ADMIN','BOM','BSS','BSSX','BOMX']

      }
      ,
      {
        label: 'Settings',
        routerLink: '/settings',
        authorizeTo:['ADMIN','BOM','BSS','ANALYST','HHD','BSSX','BOMX','CLN','CLNX','CLNSX','CLNLNX','LNX']
        //icon:'pi pi-setting'
      },	// FREQ-685039 Role-based Entitlements
      {
        label: 'Reports',
        routerLink: '/reports',
        authorizeTo:['*']
        //icon:'pi pi-file'
      }
      ,
      {
        label: 'Administrator',
        //routerLink: '/administrator/ServiceRequest',//Changed By Harikesh on 10-July-2020
        routerLink: '/administrator',
        authorizeTo:['ADMIN','BOM','BOMX']
        //icon:'pi pi-user'
      },
      {
        label: 'Villageweb',
        //  routerLink: ConfService.conf.environment.villageWebUrl,
        authorizeTo:['*']
        //icon:'pi pi-user'
      }
      ,
      {
        label: 'Logout',
        icon: 'pi pi-power-off',
        authorizeTo:['*']
      }
    ];
    //let result =authJson.filter(x=>x.authorizeTo.filter(y=>y==bartRoleCode || y=='*'))
    let result =authJson.filter((element) => 
                    element.authorizeTo.some((subElement) => subElement === bartRoleCode || subElement==="*" ))
    .map(data => ({ 
      label: data.label, 
      icon: data.icon,
      routerLink:data.routerLink,
      command:data.label=="Logout"?(event: Event) => {this.logOut();}:data.label=="Villageweb"?(event: Event) => {this.gotoVillageWeb();}:null
     }));

    return result
  }
  logOut() {
    // localStorage.clear();
    this.authService.signOut();
  }
  gotoVillageWeb()
  {
   window.location.href=ConfService.conf.environment.villageWebUrl
  }
  //#region   Labs section submenu 
  getLabsSubMenuList(bartRoleCode:string): any[] {
    let authJson= [
      {
        label: 'Lab Request Action Items',
        routerLink: '/WaterLab',
        authorizeTo:['*']
      },
      {
        label: 'Lab Requests',
        routerLink: '/WaterLab/LabRequest',
        authorizeTo:['*']
      },
      {
        label: 'Shipping Manifest',
        routerLink: '/WaterLab/ShippingManifest',
        authorizeTo:['*']
      }
      ,
      {
        label: 'Lab Results',
        routerLink: '/WaterLab/LabResults',
        authorizeTo:['*']
      }
    ];
    let result =authJson.filter((element) => 
                    element.authorizeTo.some((subElement) => subElement === bartRoleCode || subElement==="*" ))
    .map(data => ({ 
      label: data.label, 
      routerLink:data.routerLink,
     }));
    return result
  }
  //#endregion Labs section submenu 
}
